import { render } from "./course.vue?vue&type=template&id=6b18adca&scoped=true"
import script from "./course.vue?vue&type=script&lang=js"
export * from "./course.vue?vue&type=script&lang=js"

import "./course.vue?vue&type=style&index=0&id=6b18adca&lang=scss&scoped=true"

import exportComponent from "F:\\Code3\\hwh-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b18adca"]])

export default __exports__